import { PLUGIN } from "src/app/common/enums/plugins";
export const MARKETING_CRM_GUID_MAP: Record<PLUGIN, string | null> = {
  [PLUGIN.STREET_LIGHTING]: "6c702fee-dced-ef11-9341-7c1e528741da",
  [PLUGIN.SHOPPING_CART]: "6c702fee-dced-ef11-9341-7c1e528741da",
  [PLUGIN.NOYSEE]: "d0f74896-8ef5-e911-a813-000d3ab9dc22",
  [PLUGIN.KEM]: "e69787c1-58db-f011-8544-000d3ab5a051",
  [PLUGIN.CO2_BALANCE]: "27329f37-3831-e911-a9a9-000d3ab6ed20",
  [PLUGIN.DIGINAMIC]: "597dd659-1262-ea11-a811-000d3a6546b8",
  [PLUGIN.KWP]: "879241cd-09be-ef11-b8e8-7c1e523548ca",
  [PLUGIN.QUICK_CHECK]: "",
  [PLUGIN.CAMPUS_ONE]: null // campusOne has its own order form and collects leads in a different way
};
